import './Signup.css'
import { auth, db } from '../../config'
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'
import { doc, setDoc } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'

const Signup = () => {
  const nav = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const userName = e.target[0].value
    const email = e.target[1].value
    const password = e.target[2].value

    try {
      const respond = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      )
      await updateProfile(respond.user, {
        displayName: userName,
      })

      await setDoc(doc(db, 'user', respond.user.uid), {
        uid: respond.user.uid,
        displayName: userName,
        email,
      })

      await setDoc(doc(db, 'usergroups', respond.user.uid), {})

      nav('/')
    } catch (err) {
      alert(err.message)
      console.log('Fail to signup')
    }
  }

  return (
    <div className="signup">
      <h1>Signup</h1>
      <form onSubmit={handleSubmit}>
        <input type={'text'} placeholder={'User Name'} />
        <input type={'email'} placeholder={'Email'} />
        <input type={'password'} placeholder={'Password'} />
        <button type={'submit'}>Sign up</button>
      </form>
    </div>
  )
}

export default Signup
